export default __webpack_public_path__ + "static/media/toboggan.d68f3c2c.webp";